import { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { useRouter } from "next/router"
import Link from "next/link"

import { mediaPropTypes, linkPropTypes } from "../../../utils/types"

import MobileNavMenu from "../mobile-nav-menu"
import CustomLink from "../custom-link"
import AccountButton from "../account-button"



import LogoButton from "./logo-button"
import ShoppingBag from "../../ecwid/shopping-bag"

export const Navbar2 = ({ navbar, pageContext }) => {
  const router = useRouter()
  const pathname = router.pathname

  const [isOpen, setIsOpen] = useState(false)
  const [isHome, setIsHome] = useState(true)
  const [isScrolled, setIsScrolled] = useState(false)
  const toggleMenu = () => setIsOpen(!isOpen)

  const logoSrc = navbar?.logo || "/logo.png";
  const logoAlt = navbar?.logo?.alt || "Browned & Toasted logo";

  useEffect(() => {
    if (isHome) {
      const detectScrollY = () => {
        if (window.scrollY > 5) {
          setIsScrolled(true)
        } else {
          setIsScrolled(false)
        }
      }

      window.addEventListener("scroll", detectScrollY)

      return () => {
        window.removeEventListener("scroll", detectScrollY)
      }
    }
  }, [isHome])

  useEffect(() => {
    pathname === "/" ? setIsHome(true) : setIsHome(false)
  }, [pathname])

  const isActivePath = (url) => {
    if (!url || !url.startsWith("/")) return false
    if (url === "/") return pathname === "/"
    return pathname === url || pathname.startsWith(`${url}/`)
  }

  const desktopLinkClasses = (url, isPrimary = false) => {
    const isActive = isActivePath(url)

    return [
      "relative whitespace-nowrap rounded-full px-2 py-2 text-[13px] transition-all duration-200 lg:px-3 lg:text-sm",
      isPrimary ? "font-bold" : "font-semibold",
      "text-chocolate/90 hover:-translate-y-0.5 hover:bg-chocolate/10 hover:text-black",
      "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-chocolate/40",
      "after:absolute after:bottom-1 after:left-3 after:right-3 after:h-[2px]",
      "after:origin-left after:scale-x-0 after:bg-chocolate/65 after:transition-transform after:duration-200",
      isActive
        ? "bg-chocolate/15 text-black after:scale-x-100"
        : "hover:after:scale-x-100 focus-visible:after:scale-x-100",
    ].join(" ")
  }

  return (
    <nav
      className={`border-b border-chocolate/15 bg-sunrise/95 supports-[backdrop-filter]:bg-sunrise/90 transition-[box-shadow,background-color,backdrop-filter] duration-300 ${
        isScrolled ? "shadow-[0_10px_24px_rgba(63,36,21,0.18)] backdrop-blur-sm" : "shadow-none"
      }`}
    >
      <div className="mx-auto w-full max-w-6xl pl-2 pr-1 sm:px-4 lg:px-8">
        <div className={`flex items-center transition-[height] duration-300 ${isScrolled ? "h-12" : "h-14"}`}>

          <button
            onClick={toggleMenu}
            className="inline-flex items-center justify-center rounded-full p-1.5 text-chocolate/90 transition hover:bg-chocolate/10 hover:text-black focus:outline-none focus-visible:ring-2 focus-visible:ring-chocolate/40 lg:hidden"
             aria-label="Toggle navigation menu"
            aria-expanded={isOpen}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 transition-transform"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              {isOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" d="M3 6h18M3 12h18M3 18h18" />
              )}
            </svg>
          </button>

          <LogoButton
            media={navbar.logo}
            className={`ml-1 mr-1 flex min-w-0 w-[52vw] min-w-[155px] max-w-[220px] items-center transition-transform duration-300 sm:w-[170px] lg:ml-0 lg:mr-0 lg:w-[220px] ${
              isScrolled ? "md:scale-95" : "scale-100"
            }`}
          />
 

          <div className="ml-4 hidden min-w-0 flex-1 items-center lg:flex lg:ml-8">
            <div className="flex min-w-0 items-center gap-1 pr-2">
              <CustomLink
                className={desktopLinkClasses("/store", true)}
                link={{ id: 'store-link', url: '/store', text: 'Shop', newTab: false }}
                locale={router.locale}
              >
                Shop
              </CustomLink>
              <CustomLink
                className={desktopLinkClasses("/find-us", true)}
                link={{ id: 'find-us-link', url: '/find-us', text: 'Pop-Ups', newTab: false }}
                locale={router.locale}
              >
                Pop-Ups
              </CustomLink>
              {navbar.links.map((navLink) => (
                <CustomLink link={navLink} locale={router.locale} key={navLink.url}
                  className={desktopLinkClasses(navLink.url)}>
                   {navLink.text}
                </CustomLink>
              ))}

              {/* {<CustomLink className="hover:text-crimson" link={{ id: 'wholesale-link', url: '/wholesale', text: 'Sell Our Products', newTab: false }} locale={router.locale}>Wholesale</CustomLink>} */}

              {/* {<CustomLink className="hover:text-crimson" link={{ id: 'catering-link', url: '/catering', text: 'Catering', newTab: false }} locale={router.locale}>Catering</CustomLink>} */}
            </div>
          </div>
          {/* <!-- Spacer --> */}
          <div className="ml-auto mr-0.5 flex shrink-0 items-center gap-0.5 sm:gap-2">
            <AccountButton className="rounded-full p-1 text-chocolate/90 transition-all duration-200 hover:-translate-y-0.5 hover:bg-chocolate/10 hover:text-black focus-visible:ring-2 focus-visible:ring-chocolate/40 sm:p-2 [&_svg]:h-5 [&_svg]:w-5 sm:[&_svg]:h-6 sm:[&_svg]:w-6" />

            <Link
              href="/store/cart"
              aria-label="View cart"
              className="inline-flex items-center justify-center rounded-full p-1 text-chocolate/90 transition-all duration-200 hover:-translate-y-0.5 hover:bg-chocolate/10 hover:text-black focus-visible:ring-2 focus-visible:ring-chocolate/40 lg:hidden"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                className="h-5 w-5 sm:h-6 sm:w-6"
              >
                <circle cx="9" cy="20" r="1" />
                <circle cx="17" cy="20" r="1" />
                <path d="M3 4h2l2.2 10.2a2 2 0 0 0 2 1.6H17a2 2 0 0 0 2-1.6L21 7H7" />
              </svg>
            </Link>

            <div className="hidden rounded-full p-2 text-chocolate/90 transition-all duration-200 hover:-translate-y-0.5 hover:bg-chocolate/10 hover:text-black lg:block">
              <ShoppingBag storeId="100774270" className="text-chocolate/90 hover:text-black" />
            </div>
          </div>
        </div>
      </div>

      {/* Display the mobile menu */}
      {isOpen && (
        <MobileNavMenu
          navbar={navbar}
          closeSelf={() => setIsOpen(false)}
        />
      )}
    </nav>
  )};
